module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.orderedSubmissions.length) ? _c('div', {
    staticClass: "relative px-3"
  }, [(
    _vm.submissionsCount &&
    ((_vm.hasTeacherPermissionsInCourse && !_vm.genieRecap.id) || _vm.genieRecap.id)
  ) ? _c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "recap-card"
    }
  }, [_c('GenieRecap', {
    staticClass: "pb-5 px-2 border-b border-gray-100",
    attrs: {
      "submissions": _vm.submissionsCount
    },
    on: {
      "editRecap": function($event) {
        _vm.edit_recap = true
      },
      "deleteRecap": function($event) {
        _vm.delete_recap = true
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderedSubmissions), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "relative"
    }, [(!_vm.edit_prompt) ? [(index < _vm.responses.length) ? [_c('SubmissionCard', {
      key: _vm.$route.path,
      ref: "card",
      refInFor: true,
      staticClass: "feed-card relative",
      class: index === _vm.responses.length - 1 ? '' : 'border-b border-gray-100',
      attrs: {
        "submission": item,
        "id": ("feed-" + (item.id)),
        "hasNext": _vm.orderedSubmissions && _vm.orderedSubmissions.length > 1
      },
      on: {
        "openAssessmentTab": function($event) {
          return _vm.openAssessmentTab(item.id)
        },
        "showDeleteSubmissionModal": _vm.showDeleteSubmissionModal,
        "showHideSubmissionModal": _vm.showHideSubmissionModal,
        "openAnonymityModal": _vm.openAnonymityModal,
        "showAssessmentModal": _vm.showAssessmentModal
      }
    })] : _vm._e(), _vm._v(" "), (index >= _vm.responses.length) ? [(index === _vm.responses.length) ? _c('div', {
      key: item.id + 'feed-observers-divider',
      staticClass: "flex justify-center",
      attrs: {
        "id": "feed-observers-divider"
      }
    }, [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), _c('div', {
      class: _vm.orderedSubmissions.length - 1 !== index ?
        'border-gray-100 border-solid border-b' :
        ''
    }, [_c('ByPassCard', {
      key: item.id,
      attrs: {
        "id": ("feed-" + (item.id)),
        "submission": item
      },
      on: {
        "openAssessmentTab": _vm.openAssessmentTab
      }
    })], 1)] : _vm._e()] : _vm._e()], 2)
  })], 2) : _c('div', {
    staticClass: "checklist-height flex flex-col items-center justify-center"
  }, [(_vm.hasTeacherPermissionsInCourse && !_vm.studentsInvited) ? _c('Checklist', {
    attrs: {
      "roundtable": _vm.getCurrentRT
    }
  }) : _vm._e(), _vm._v(" "), (_vm.studentsInvited) ? _c('div', {
    staticClass: "h-full flex flex-col w-full relative space-y-16"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e()], 1), _vm._v(" "), (_vm.edit_prompt) ? _c('div', {
    staticClass: "transparent-modal"
  }, [_c('prompt-in-feed-modal', {
    key: 'prompt-in-feed',
    staticStyle: {
      "overflow-wrap": "break-word"
    },
    attrs: {
      "editPrompt": _vm.edit_prompt
    },
    on: {
      "toggleEditPrompt": function($event) {
        _vm.edit_prompt = !_vm.edit_prompt
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.show_delete_submission_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Delete Submission",
      "subHeader": 'Are you sure you want to delete ' +
        _vm.submissionToDelete.user.name +
        ' submission? This action is irreversible!'
    },
    on: {
      "close": function($event) {
        _vm.show_delete_submission_modal = false
      },
      "actionConfirmed": _vm.deleteSubmission
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show_hide_submission_modal) ? _c('pl-dialog', {
    attrs: {
      "size": "relative_sm",
      "title": "Hide Submission",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.show_hide_submission_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "h-full w-full overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex flex-col h-full space-y-4"
  }, [_c('div', {
    staticClass: "overflow-y-auto h-full px-5"
  }, [_c('div', {
    staticClass: "bg-gray-50 border border-gray-200 p-4 rounded-lg text-gray-800 font-manrope space-y-3"
  }, [_c('p', {
    staticClass: "text-sm"
  }, [_vm._v("\n             This will hide this student's submission and associated comments from Roundtable participants. Only you and the original poster can see it from now on.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('img', {
    staticClass: "w-8 h-8 rounded-full",
    attrs: {
      "src": _vm.submissionToHide.user.avatar_url,
      "alt": _vm.submissionToHide.user.name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-semibold text-gray-900 line-through"
  }, [_vm._v("\n                  " + _vm._s(_vm.submissionToHide.user.name) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-shrink-0 px-5 pb-3.5 flex space-x-2 font-manrope"
  }, [_c('button', {
    staticClass: "flex-1 bg-white hover:bg-gray-100 transition-colors py-2 flex items-center justify-center space-x-2 text-gray-800 rounded-lg",
    on: {
      "click": function($event) {
        _vm.show_hide_submission_modal = false
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "flex-1 bg-primary hover:bg-primary-dark transition-colors py-2 flex items-center justify-center space-x-2 text-white font-semibold rounded-lg",
    on: {
      "click": function($event) {
        return _vm.handleHideSubmission(true)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.isExecuting === true ? 'Hiding...' : 'Confirm'))]), _vm._v(" "), (_vm.isExecuting === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.show_delete_comment_dialog) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Delete Comment",
      "subHeader": 'Are you sure you want to delete this comment? This action is irreversible!'
    },
    on: {
      "close": function($event) {
        _vm.show_delete_comment_dialog = false
      },
      "actionConfirmed": _vm.deleteComment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_hide_comment_modal) ? _c('pl-confirm', {
    staticClass: "tl",
    attrs: {
      "typeConfirm": false,
      "message": "Hide Comment",
      "confirmText": "HIDE"
    },
    on: {
      "confirm": function($event) {
        return _vm.hideComment(true)
      },
      "close": function($event) {
        _vm.show_hide_comment_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "px-7 flex-grow overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex justify-center mt-9 mb-3"
  }, [_c('i', {
    staticClass: "fa-solid fa-triangle-exclamation text-yellow-400 text-3xl"
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-center text-gray-700 mb-2"
  }, [_vm._v("\n          This will hide the comment and associated comments from participants\n          in the RoundTable. Only you and the original poster can see it from\n          now on.\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show_flag_dialog) ? _c('pl-confirm', {
    staticClass: "tl",
    attrs: {
      "typeConfirm": false,
      "message": "Inappropriate Comment",
      "confirmText": "This is inappropriate!",
      "confirmColor": "bg-red-500 hover:bg-red-600 text-white"
    },
    on: {
      "confirm": function($event) {
        return _vm.closeDialog('confirm-flag', 'flag')
      },
      "close": function($event) {
        _vm.show_flag_dialog = false
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center mt-10 mb-5"
  }, [_c('i', {
    staticClass: "fa-solid fa-comment-slash text-red-500 text-3xl"
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-24 mb-6"
  }, [_c('p', {
    staticClass: "text-center text-gray-700 mb-2"
  }, [_vm._v("\n        Are you sure you want to mark\n        "), _c('span', {
    staticClass: "font-bold"
  }, [_vm._v("this comment")]), _vm._v(" as inappropriate? Use this\n        action if you "), _c('span', {
    staticClass: "font-bold"
  }, [_vm._v("feel uncomfortable")]), _vm._v(" with\n        the comment!\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.show_assessment_modal) ? _c('pl-dialog', {
    attrs: {
      "maxHeight": "80%",
      "width": "80%",
      "max-width": "700px"
    },
    on: {
      "close": function($event) {
        _vm.show_assessment_modal = false
      }
    }
  }, [(Number(_vm.getCurrentRT.point_cap) > 0) ? _c('div', {
    staticClass: "pl-subheading start-xs",
    staticStyle: {
      "padding": "10px 30px"
    }
  }, [_vm._v("\n      Max Score: " + _vm._s(Number(_vm.getCurrentRT.point_cap)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row no-margin start-xs scroll",
    staticStyle: {
      "padding": "10px 20px"
    }
  }, _vm._l((_vm.getCurrentRT.points_settings.peer_rewards), function(point) {
    return _c('div', {
      key: point.tag,
      staticClass: "col-xs-6 start-xs",
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('span', {
      staticClass: "pl-title"
    }, [_vm._v("\n          " + _vm._s(point.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pl-body-2 row no-margin start-xs middle-xs"
    }, [_c('p', [_vm._v("\n            " + _vm._s(typeof point.description === 'object' ?
      point.description.join('. ') :
      point.description) + "\n          ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.show_confirm_delete_feedback) ? _c('dialog-delete-confirm', {
    attrs: {
      "header": 'Delete this saved feedback template',
      "subHeader": 'It will be permanently removed from this course.'
    },
    on: {
      "close": _vm.cancelDeleteSavedFeedback,
      "actionConfirmed": _vm.confirmDeleteSavedFeedback
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_saved_feedback_modal) ? _c('NewFeedbackTemplateModal', {
    attrs: {
      "typeRoundtable": "online",
      "feedbackID": _vm.feedback_id,
      "feedbackContent": _vm.feedback_content,
      "editingFeedback": _vm.set_edit_saved_feedback
    },
    on: {
      "close": _vm.closeNewFeedbackModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_import_feedback_modal) ? _c('ImportFeedbackTemplatesModal', {
    attrs: {
      "typeRoundtable": "online"
    },
    on: {
      "close": _vm.closeImportFeedbackTemplatesModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_point_creation_modal) ? _c('create-new-point-modal', {
    attrs: {
      "activityType": _vm.activityType,
      "tag": _vm.selected_point_tag,
      "rts": _vm.roundtables_with_point
    },
    on: {
      "close": function($event) {
        _vm.show_point_creation_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_anonymous_description_modal) ? _c('anonymous-character-description-modal', {
    attrs: {
      "anonymous_identity": _vm.identity_to_show
    },
    on: {
      "close": function($event) {
        _vm.show_anonymous_description_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_point_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Are you sure you want to delete this Point?"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_point_modal = false
      },
      "actionConfirmed": _vm.deleteAssessmentPoint
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_alert_assessment_changing) ? [_c('pl-dialog', {
    staticClass: "center-xs",
    attrs: {
      "maxWidth": '600px',
      "padding": '2em'
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    }
  }, [_c('pl-button', {
    staticStyle: {
      "min-width": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeAssessmentChangingAlert.apply(null, arguments)
      }
    }
  }, [_c('strong', {
    staticClass: "f4"
  }, [_vm._v("X")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "header pv3"
  }, [_c('span', {
    staticClass: "pl-secondary b",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("Heads up!")])]), _vm._v(" "), _c('div', {
    staticClass: "ph3",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('p', [_vm._v("\n          Changing (or deleting) this assessment criteria for this RoundTable\n          will change (or delete) it for all of the other RoundTables in this\n          course that also use this criteria:\n        ")]), _vm._v(" "), _c('ul', _vm._l((_vm.displayCriteriaRts), function(roundtable) {
    return _c('li', {
      key: roundtable.id,
      staticClass: "b"
    }, [_vm._v("\n            " + _vm._s(roundtable.title) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pv2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "font-size": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeAssessmentChangingAlert.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Okay, Got it.\n        ")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.show_unsubmitted_modal) ? _c('pl-dialog', {
    attrs: {
      "height": "80%",
      "maxWidth": "630px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "top": "12px",
      "right": "12px",
      "margin": "0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_unsubmitted_modal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-lg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "avatar-circle avatar-size ml3"
  }, [_c('img', {
    attrs: {
      "src": _vm.unsubmitted_response.user.avatar_url,
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tl ml3"
  }, [_c('p', {
    staticClass: "ma0 pl-title"
  }, [_vm._v(_vm._s(_vm.unsubmitted_response.user.name))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "ma0 ruby-text i"
  }, [_vm._v("Unsubmitted")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "unsubmitted-text-section"
  }, [_c('section', {
    staticClass: "prompt-response ph3 tl",
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.unsubmitted_response.draft_response)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "i pl3 tl mt4",
    staticStyle: {
      "font-size": "12px",
      "color": "#273248"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.unsubmitted_response.word_count) + " Words\n      ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.delete_recap) ? _c('DialogDeleteConfirm', {
    attrs: {
      "title": _vm.delete_recap_information.title,
      "content": _vm.delete_recap_information.description,
      "processing": _vm.is_processing_action
    },
    on: {
      "close": function($event) {
        _vm.delete_recap = false
      },
      "action": function($event) {
        return _vm.deleteGenieRecap()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.edit_recap) ? _c('EditGenieRecapModal', {
    attrs: {
      "genieRecap": _vm.genieRecap
    },
    on: {
      "close": function($event) {
        _vm.edit_recap = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center w-full"
  }, [_c('div', {
    staticClass: "col-xs m-auto border-b border-solid border-gray-300 rounded"
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-3 text-sm font-medium text-gray-400"
  }, [_vm._v("\n                Observers\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs m-auto border-b border-solid border-gray-300 rounded"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full mt-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/online_roundtable_icons/blank_submissions.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col ml-8 items-center justify-center text-base"
  }, [_c('h3', {
    staticClass: "text-center font-semibold"
  }, [_vm._v("\n          No Students responses yet...\n        ")]), _vm._v(" "), _c('span', [_vm._v("Click on student names to view their draft responses.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0d670d11!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/tabs/discussionTab.vue
// module id = 1118
// module chunks = 61